import { BaseRouteService } from 'core/services';

class SellerOrganizationInfoRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'seller-organization-infos/';
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}
}

export default SellerOrganizationInfoRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/SellerOrganizationInfoRouteService.js